// extracted by mini-css-extract-plugin
export default {"container":"current-user_container__5s+rw","user":"current-user_user__uYH7x"};